module.exports = __webpack_public_path__ + "static/media/entrance-cgi.1fbc7be4.jpg";